import { FooterBrand, FooterContact, FooterExplore, FooterLegal, FooterOffices } from "./FooterParts";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#082F24] text-[#E8F3EE] grain">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-24 pb-10">
      <div className="grid gap-12 md:grid-cols-12">
        <FooterBrand />
        <FooterExplore />
        <FooterContact />
        <FooterOffices />
      </div>
      <p data-testid="footer-brand-wordmark" aria-hidden="true" className="mt-20 font-display text-5xl sm:text-7xl lg:text-[5.5rem] xl:text-[6rem] leading-[1.05] text-[#FAF8F5]/[0.12] select-none">Emerald Global Advisory</p>
      <FooterLegal />
    </div>
  </footer>
);